// import { DeviceReadings, DeviceReadingData, DeviceConfig } from '../components'

export function DeviceDetailsPage() {
  return (
    <div className={tailwind.container}>
      <h2>Details Details</h2>
      {/* <DeviceConfig config={config} />
      <DeviceReadings data={data} /> */}
    </div>
  )
}

const tailwind = {
  container: 'mt-3 mx-10',
}
